module.exports = __webpack_public_path__ + "img/service_header.1bdaf93b.png";